import { useEffect, useCallback, useState } from 'react';
import socketService from '../websocket/socket';
import useAuth from './useAuth';
import useChat from './useChat';

/**
 * Custom hook for WebSocket communication
 * @returns {Object} WebSocket methods and state
 */
const useWebSocket = () => {
  const { user } = useAuth();
  const [isConnected, setIsConnected] = useState(socketService.isSocketConnected());
  
  // Connect to WebSocket when authenticated
  useEffect(() => {

    console.log("WEBSOCKET --- Intiailizing.. : ", user)

    // If user is authenticated, connect to WebSocket
    if (user && user.data.user && user.data.user._id) {
      socketService
        .connect(user.data.user._id)
        .then(() => {
          setIsConnected(true);
          console.log("Websocket connected")
        })
        .catch((error) => {
          console.log('WebSocket connection error:', error);
          setIsConnected(false);
        });
    } else {
      // Disconnect if not authenticated
      socketService.disconnect();
      setIsConnected(false);
    }
    
    // Clean up on unmount
    return () => {
      // Disconnect only if component is completely unmounting
      // This check prevents disconnecting during re-renders
      if (!user) {
        socketService.disconnect();
      }
    };
  }, [user]);
  
  // Function to send a message
  const sendMessage = useCallback((data) => {
    return socketService.sendMessage(data);
  }, []);
  
  // Function to add an event listener
  const addEventListener = useCallback((eventType, callback) => {
    socketService.on(eventType, callback);
    
    // Return cleanup function
    return () => {
      socketService.off(eventType, callback);
    };
  }, []);
  
  // Function to remove an event listener
  const removeEventListener = useCallback((eventType, callback) => {
    socketService.off(eventType, callback);
  }, []);
  
  return {
    isConnected,
    sendMessage,
    addEventListener,
    removeEventListener,
  };
};

export default useWebSocket;